<template>
    <div>
        <div class="comment-header">
            <div class="comment-header-pic"  @click.stop="gotomy(item)">
                <img :src="$baseurl+item.headImg">
            </div>
            <div class="comment-header-wz">
                <div class="comment-header-wz-tit">{{item.nick}}</div>
                <div class="comment-header-wz-stit" v-if="item.signature">{{item.signature}}</div>
                <div class="comment-header-wz-stit" v-if="!item.signature">未设置</div>
            </div>
            <div class="comment-right" @click.stop="like(item)" v-if="showricon">
                <van-icon class="comment-right-icon" :size="18" v-if="!item.isLike"   name="like-o" />
                <van-icon class="comment-right-icon" :size="18" v-if="item.isLike" color="red"   name="like" />
                <span style="margin-left:5px;vertical-align:4px;" v-if="item.giveLikeCount">{{item.giveLikeCount}}</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'commenthead',
    props:{
        item:{
            type:Object,
            default:undefined
        },
        showricon:{
            type:Boolean,
            default:false
        }
    },
    data()
    {
        return {
            
        }
    },
    created(){

    },
    methods:{
        gotomy(item){
            this.$router.push({path:'/communitymy',query:{id:item.memberPersonalId}});
        },
        like(item)
        {
            this.$emit('like',item);
        }
    }

}
</script>
<style lang="scss" scoped>
    .comment-header{
        padding-left:50px;
        padding-right:30px;
        position: relative;
        min-height: 45px;
        line-height: 23px;
    }
    .comment-header-pic{
        position: absolute;
        left:0;
        width: 40px;
        height: 40px;
    }
    .comment-header-pic img{
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }
    .comment-right{
        position: absolute;
        right:0;
        top:0;
    }
    .comment-header-wz-tit{
        font-size: 14px;
    }
    .comment-header-wz-stit{
        font-size: 12px;
        color:#a8a8a8;
    }
</style>